/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Calm_Fox_GleamInputs */

const en_bold_calm_fox_gleam = /** @type {(inputs: Bold_Calm_Fox_GleamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Override the default minimum answers`)
};

const de_bold_calm_fox_gleam = /** @type {(inputs: Bold_Calm_Fox_GleamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-Mindestantworten überschreiben`)
};

/**
* | output |
* | --- |
* | "Override the default minimum answers" |
*
* @param {Bold_Calm_Fox_GleamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_calm_fox_gleam = /** @type {((inputs?: Bold_Calm_Fox_GleamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Calm_Fox_GleamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_calm_fox_gleam(inputs)
	return de_bold_calm_fox_gleam(inputs)
});